// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"b20d35ea","456":"9433a487","656":"591bd67f","756":"9f13f62f","787":"231b781f","968":"8d4494aa"}[chunkId] + ".chunk.js";
};